import type { BusinessUnitConfig, BusinessUnitKey } from './bu.types';

export * from './bu.types';

/**
 * Every product that ships owns its own `bu.config.ts` inside its module
 * folder and is discovered here by filename. Nothing in this file names a
 * product, so deleting `src/modules/<product>/` removes it from the registry,
 * the router and the BU chooser without touching shared code.
 */
const configModules = import.meta.glob<{ config: BusinessUnitConfig }>('../*/bu.config.ts', {
  eager: true,
});

export const BUSINESS_UNITS: BusinessUnitConfig[] = Object.values(configModules)
  .map((module) => module.config)
  .sort((a, b) => a.order - b.order);

export function getBusinessUnitConfig(key_value: BusinessUnitKey | undefined) {
  if (!key_value) return undefined;
  return BUSINESS_UNITS.find((bu) => bu.key === key_value);
}
